// PLAN.md §2.2 — middle (spectator) column: price, chart, timeframe, crowd, bank action.

import { useMemo } from 'react'
import type { LivelinePoint } from '../ported/index.js'
import { ChartRangeToggle, Liveline } from '../ported/index.js'
import { useStore } from '../../store.js'
import { fetchPriceHistory } from '../../socket.js'
import { PriceHeader } from './PriceHeader.js'
import { SpectatorCrowd } from './SpectatorCrowd.js'
import { ExitAndProfitBar } from './ExitAndProfitBar.js'
import { fmtTimeShort, fmtUsd } from '../../format.js'

const SLICE_BY_TIMEFRAME: Record<'15m' | '1h' | '4h', number> = {
  '15m': 900,
  '1h': 3600,
  '4h': 14_400,
}

export function SpectatorColumn() {
  const priceRing = useStore((s) => s.priceRing)
  const timeframe = useStore((s) => s.timeframe)
  const setTimeframe = useStore((s) => s.setTimeframe)

  const slice = SLICE_BY_TIMEFRAME[timeframe]
  const points: LivelinePoint[] = useMemo(
    () =>
      priceRing.slice(-slice).map((p) => ({
        t: new Date(p.t).toISOString(),
        value: p.price,
      })),
    [priceRing, slice],
  )

  return (
    <div className="flex flex-col h-full justify-between gap-4 py-4">
      <PriceHeader />
      <div className="flex flex-col gap-2 px-2">
        <Liveline
          points={points}
          height={140}
          gradient
          crosshair
          pulseLast
          formatValue={fmtUsd}
          formatDate={fmtTimeShort}
          minRangePct={0.0005}
        />
        <div className="flex justify-center">
          <ChartRangeToggle
            range={timeframe}
            onRangeChange={(r) => {
              setTimeframe(r)
              if (r === '1h' || r === '4h') fetchPriceHistory(r)
            }}
            options={['15m', '1h', '4h']}
          />
        </div>
      </div>
      <SpectatorCrowd />
      <ExitAndProfitBar />
    </div>
  )
}
